import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormService } from '../../services/form.service';

@Component({
    selector: 'app-subform',
    templateUrl: './subform.component.html',
    styleUrls: ['./subform.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SubformComponent implements OnInit {
  @Input() configData;    
  @Input() frmGroup: UntypedFormGroup;
  color: String = 'primary';
  mode: String = 'indeterminate';
  isLoading = false;

  constructor(private formService: FormService) { }

  ngOnInit() {
    // this.frmGroup = this.formService.createForm(this.configData);
    this.frmGroup = this.frmGroup[this.configData.name];
    console.log(this.frmGroup);
    console.log(this.configData);
  }

  getColsClass(cols: number[], control?: any) {
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    for (let i = 0; i < cols.length; i++) {
      colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }    
    return colsClass;
  }
}
